export default __webpack_public_path__ + "static/home2-06deb47d950c6aa09e4986100b46a15b.jpg";